import {
    MESSAGE_KEY_FORM_SIZE,
    MESSAGE_KEY_REDIRECT,
    MESSAGE_KEY_DO_RENDER_CAPTCHA,
    MESSAGE_KEY_DO_TAKE_CAPTCHA_TOKEN,
    MESSAGE_DATA_OBJECT_KEY,
    EVENT_KEY_ORIGIN,
    MESSAGE_KEY_SCROLL_TO_FRAME,
    MESSAGE_KEY_SUBMIT_SUCCESS,
    MESSAGE_KEY_RETRIEVE_FORM_SOURCE,
    MESSAGE_KEY_RENDER_FORM_SOURCE,
    MESSAGE_KEY_HIDE_FRAME,
    MESSAGE_KEY_SUBMIT_FAILED,
    MESSAGE_KEY_DO_FORWARD,
    MESSAGE_KEY_ON_CAPTCHA_TOKEN,
    MESSAGE_KEY_FETCH_FORM_DATA,
    MESSAGE_KEY_ON_FORM_READY,
    MESSAGE_KEY_ON_FORM_RENDERED,
    MESSAGE_KEY_RENDER_TERM_AND_CONDITION_CONTENT,
    MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE,
    MESSAGE_KEY_PAGE_CHANGED,
    MESSAGE_KEY_DZ_FILE_UPLOAD,
    MESSAGE_KEY_CUSTOM_HTML_WIDGET,
    MESSAGE_KEY_ON_FORM_BEFRORE_RENDER,
    MESSAGE_KEY_CAN_RENDER_FORM
} from "../../core/const/Constant.js";
import Logger from "../../core/utils/Logger.js";
import Utils from "../utils/Common.util.js";
import Observer from "./Observer.js";
import { doPostMessage, registerForwardMessageByKey, setRecipientOrigin, subscribeMessage } from "../../core/services/MessageService.js";
import { APP_FORM_CSS_URL, APP_FORM_JS_URL } from '../../ENV.js';



const unSubcribeTrackingDomain = Observer.SubscribeEvent(EVENT_KEY_ORIGIN, (domain) => {
    setRecipientOrigin(domain);
})

subscribeMessage(MESSAGE_KEY_RETRIEVE_FORM_SOURCE, () => {

    const formScript = Utils.querySelector('script#taiFormScript');
    const formCSS = Utils.querySelector('link#taiFormStyle');
    const payload = {
        scripts: [APP_FORM_JS_URL],
        styles: [APP_FORM_CSS_URL]
    }
    doPostMessage(MESSAGE_KEY_RENDER_FORM_SOURCE, payload);
})

/**If the form render directly (on-site mode), register the keys need to be forward, */
registerForwardMessageByKey([
    MESSAGE_KEY_DO_RENDER_CAPTCHA,
    MESSAGE_KEY_DO_TAKE_CAPTCHA_TOKEN,
    MESSAGE_KEY_SUBMIT_SUCCESS,
    MESSAGE_KEY_SUBMIT_FAILED,
    MESSAGE_KEY_ON_CAPTCHA_TOKEN,
    MESSAGE_KEY_REDIRECT,
    MESSAGE_KEY_RENDER_TERM_AND_CONDITION_CONTENT,
    MESSAGE_KEY_ON_FORM_RENDERED,
    MESSAGE_KEY_ON_FORM_BEFRORE_RENDER,
    MESSAGE_KEY_CUSTOM_VALIDATE_MESSAGE,
    MESSAGE_KEY_PAGE_CHANGED,
    MESSAGE_KEY_CUSTOM_HTML_WIDGET,
    MESSAGE_KEY_CAN_RENDER_FORM
])

class Message {
    static PostOtherMessage = (key, value) => doPostMessage(key, value);
    static PostResize = (width, height) => doPostMessage(MESSAGE_KEY_FORM_SIZE, { width, height });
    static PostRedirectTo = (url = '') => doPostMessage(MESSAGE_KEY_REDIRECT, { url, target: '' });
    static PostRenderReCapcha = (key, version) => doPostMessage(MESSAGE_KEY_DO_RENDER_CAPTCHA, { key, version });
    static PostTakeCapchaToken = () => doPostMessage(MESSAGE_KEY_DO_TAKE_CAPTCHA_TOKEN, 1);
    static PostScrollToFrame = () => doPostMessage(MESSAGE_KEY_SCROLL_TO_FRAME, 1);
    static PostSubmitFormSuccess = () => doPostMessage(MESSAGE_KEY_SUBMIT_SUCCESS, 1);
    static PostSubmitFormFailed = (value) => doPostMessage(MESSAGE_KEY_SUBMIT_FAILED, value);
    static PostHideFrame = () => doPostMessage(MESSAGE_KEY_HIDE_FRAME, 1);
    static PostFormReady = () => doPostMessage(MESSAGE_KEY_ON_FORM_READY, 1);
    static PostFormBeforeRender = () => doPostMessage(MESSAGE_KEY_ON_FORM_BEFRORE_RENDER, 1);
    static PostFormRendered = () => setTimeout(() => { doPostMessage(MESSAGE_KEY_ON_FORM_RENDERED, 1) }, 100);
    static PostFormPageChanged = (pageIndex) => { doPostMessage(MESSAGE_KEY_PAGE_CHANGED, pageIndex) };
}

export default Message;
export { subscribeMessage };